import { atom } from 'jotai';

import {
  ROOM_MODE_OPTIONS,
  type TYPE_DESIRED_COLOR_OPTIONS,
  type TYPE_DESIRED_STYLE_OPTIONS,
  type TYPE_MATERIAL_OPTIONS,
  type TYPE_ROOM_MODE_OPTIONS,
  type TYPE_ROOM_TYPE_OPTIONS,
} from '../constants/style-settings';
import {
  EDIT_IMAGE_METHOD,
  type TYPE_EDIT_IMAGE_METHOD,
  type TYPE_MAGIC_TOOL_OPTIONS,
} from '../constants/toggle-group-options';

export const editMethodAtom = atom<TYPE_EDIT_IMAGE_METHOD>(EDIT_IMAGE_METHOD.STYLE);
export const magicToolOptionAtom = atom<TYPE_MAGIC_TOOL_OPTIONS | null>(null);

export const roomModeSettingsAtom = atom<TYPE_ROOM_MODE_OPTIONS>(ROOM_MODE_OPTIONS.CHANGE_STYLE);
export const roomTypeSettingsAtom = atom<TYPE_ROOM_TYPE_OPTIONS>();
export const desiredStyleSettingsAtom = atom<TYPE_DESIRED_STYLE_OPTIONS>();
export const desiredColorSettingsAtom = atom<TYPE_DESIRED_COLOR_OPTIONS[]>([]);
export const materialSettingsAtom = atom<TYPE_MATERIAL_OPTIONS[]>([]);

export const settingsChangedAtom = atom(false);
export const settingsFilledAtom = atom(
  (get) =>
    Boolean(get(roomTypeSettingsAtom)) &&
    Boolean(get(desiredStyleSettingsAtom)) &&
    Boolean(get(roomModeSettingsAtom))
);
